
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import Header from '../Header';
import Footer from '../Footer';
import config from '../../config';
import React, { useState,useEffect } from 'react';
import PopupService from '../PopupService';
import { format } from 'date-fns';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useApi } from '../../ApiContext';
import { apiFetch } from '../utils/ApiFetch';

const ExportAlert = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const data = location.state;
  const [loading, setLoading] = useState(false);
  const { callApi, setIsApiLoading } = useApi();
  const username = sessionStorage.getItem('username');
  const mrToken = localStorage.getItem('mr_token');
  const [attachments, setAttachments] = useState([]);
  const [noticeTasks, setNoticeTasks] = useState([]);
  const [clientAttachments, setClientAttachments] = useState({});  
  const [clientAssociation, setClientAssociation] = useState({});
  const [supportAlert, setSupportAlert] = useState({});
  const [noticeTaskAttachments, setNoticeTaskAttachments] = useState([]);
  const [expandedEmailIdx, setExpandedEmailIdx] = useState(null);
  const [receivedDate, setReceivedDate] = useState(null);
  const [alertClients, setAlertClients] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);	
  const [showAlertDetails, setShowAlertDetails] = useState(false);
  const [alertExported, setAlertExported] = useState(false);
  const [stageId, setStageId] = useState(null);
  
  const handleBack = () => {
    const lastPage = sessionStorage.getItem('lastPage');
    navigate('/home', { state: { page: lastPage ? Number(lastPage) : 1 } });
  };
  
  const allAttachments = [
    ...attachments.map(file => ({
      type: 'alert',
      id: file.mongoId,
      fileName: file.fileName,
      clientId: file.clientId,
      attachmentType: file.attachmentType || 'SA'
    })),
    ...Object.entries(clientAttachments).flatMap(([mongoId, attList]) =>
      attList.map(att => ({
        type: 'client',
        id: att[0],           // attachmentId
        fileName: att[1],     // filename
        clientId: data.clientId,
        attachmentType: att[2]
                       // <-- map key added here
      }))
    )
  ];
  

  async function isPythonApiRunning() {
    try {
      const response = await apiFetch(`${config.API_PY_URL}/health`, { method: 'GET' });
      return response.ok;
    } catch {
      return false;
    }
  }

 
  useEffect(() => {
    const fetchPreExportAlert = async () => {
      try {
		const response = await apiFetch(`${config.API_BASE_URL}/preExportAlert`, {
		    method: 'POST',
		    headers: {
		      'Content-Type': 'application/json',
		      'X-Username': username,
		      'Authorization': `Bearer ${mrToken}`,
		    },
		    body: JSON.stringify({ mrNumber: data.mrNumber, clientId: data.clientId, mongoId: data.mongoId }),
		  });
        if (response.ok) {
          const data = await response.json();
          setAttachments(data?.data?.ATTACHMENT_LIST || []);
          setNoticeTasks(data?.data?.NOTICE_TASK_LIST || []);
          setClientAttachments(data?.data?.ALERT_CLIENT_ATTCH_LIST || {});
		  setClientAssociation(data?.data?.ALERT_CLIENT_ASSOCIATED );
		  setAlertExported(data?.data?.ALERT_EXPORTED);
		  setSupportAlert(data?.data?.SUPPORT_ALERT );
		  setStageId(data?.data?.STAGE_ID)
		  setShowAlertDetails(false)
        }
      } catch (e) {
        setAttachments([]);
        setNoticeTasks([]);
        setClientAttachments({});
      }
    };
    fetchPreExportAlert();
  }, [username, mrToken]);
  
  const downloadAttachment = async (mongoId, fileName, attachmentType = 'SA') => {
    try {
      let url;
      if (attachmentType === 'NT') {
        url = `${config.API_BASE_URL}/downloadNTAttachment/${mongoId}`;
      } else {
        url = `${config.API_BASE_URL}/attachment_download/${mongoId}`;
      }
      const response = await apiFetch(url, {
        headers: {
          'X-Username': username,
          'Authorization': `Bearer ${mrToken}`
        }
      });
      if (!response.ok) throw new Error('Download failed');
      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = downloadUrl;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(downloadUrl);
    } catch (e) {
      PopupService.getInstance().showMessage('Failed to download attachment', false);
    }
  };
  
  const deleteAlertAttachment = async (id, clientId, attachmentType = 'SA') => {
    if (!data.mrNumber || !clientId || !id) {		
      PopupService.getInstance().showMessage('Missing parameters: MR Number, Client ID, or Attachment ID', false);
      return;
    }
    const confirmed = await PopupService.getInstance().showConfirm(
      'Are you sure you want to delete this attachment?'
    );
    if (!confirmed) return;

    const formData = new FormData();
    formData.append('mrNumber', data.mrNumber);
    formData.append('clientId', data.clientId);
    formData.append('attachmentId', id);
    formData.append('enteredBy', username);

    try {
      const response = await apiFetch(`${config.API_BASE_URL}/deleteAttachment`, {
        method: 'DELETE',
        headers: {
          'X-Username': username,
          'Authorization': `Bearer ${mrToken}`
        },
        body: formData
      });
      const result = await response.json();
      if (response.ok && result.statusCode === 200) {
        setAttachments((prev) => prev.filter((file) => file.mongoId !== id));
        PopupService.getInstance().showMessage(result.message || 'Attachment Deleted Successfully', true);
  	  setAlertClients(prev =>
  	    prev.map(client => ({
  	      ...client,
  	      alertClientEntry: (client.alertClientEntry || []).map(entry => ({
  	        ...entry,
  	        attachments: (entry.attachments || []).filter(att => att[0] !== id)
  	      }))
  	    }))
  	  );
      } else {
        PopupService.getInstance().showMessage(result.message || 'Failed to delete attachment', false);
      }
    } catch (error) {
      PopupService.getInstance().showMessage('Failed to delete attachment', false);
    }
  };
  
  const deleteClientAttachment = async (noticeAttachmentId, alertClientId) => {
    const confirmed = await PopupService.getInstance().showConfirm(
      'Are you sure you want to delete this client attachment?'
    );
    if (!confirmed) return;

    const formData = new FormData();
    formData.append('alertClientId', alertClientId);
    formData.append('attachmentId', noticeAttachmentId);
    formData.append('mrNumber', data.mrNumber);
    formData.append('clientId', data.clientId);
    formData.append('enteredBy', username);

    try {
      const response = await apiFetch(`${config.API_BASE_URL}/deleteClientAttachment`, {
        method: 'DELETE',
        headers: {
          'X-Username': username,
          'Authorization': `Bearer ${mrToken}`
        },
        body: formData
      });
      const result = await response.json();

      if (response.ok && result.statusCode === 200) {
        // Remove the deleted attachment from clientAlertAttachments

  	  clientAttachments(prev => {
  	    const updated = { ...prev };
  	    Object.keys(updated).forEach(key => {
  	      updated[key] = updated[key].filter(att => att[0] !== noticeAttachmentId);
  	      if (updated[key].length === 0) {
  	        delete updated[key];
  	      }
  	    });
  	    return updated;
  	  });

        PopupService.getInstance().showMessage(result.message || 'Client attachment deleted successfully', true);
      } else {
        PopupService.getInstance().showMessage(result.message || 'Failed to delete client attachment', false);
      }
    } catch (error) {
      PopupService.getInstance().showMessage('Failed to delete client attachment', false);
    }
  };
  function unescapeHtml(text) {
    if (!text) return '';
    const temp = document.createElement('textarea');
    temp.innerHTML = text;
    return temp.value;
  }
  const handleCBChanged = async (e) => {
    const checked = e.target.checked;
    const msgId = e.target.value;
    if (checked) {
      try {
        const response = await apiFetch(`${config.API_BASE_URL}/noticeAttachment`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Username': username,
            'Authorization': `Bearer ${mrToken}`
          },
          body: JSON.stringify({ messageId: msgId })
        });
        if (response.ok) {
          const data = await response.json();
          setNoticeTaskAttachments(prev => {
            const newAttachments = data?.data?.ATTACHMENT_LIST || [];
            const existingIds = new Set(prev.map(att => String(att.messageId)));
            const filteredNew = newAttachments.filter(att => !existingIds.has(String(att.messageId)));
            return [...prev, ...filteredNew];
          });
        }
      } catch {
        // Optionally handle error
      }
    } else {
      setNoticeTaskAttachments(prev =>
        prev.filter(att => String(att.messageId) !== String(e.target.id))
      );
    }
  };
  

  // Add this function inside your ExportAlert component

  const handleEmailClicked = async (mongoId, idx) => {
	
    setExpandedEmailIdx(idx);
    try {
      const response = await apiFetch(`${config.API_BASE_URL}/emailNotice`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Username': username,
          'Authorization': `Bearer ${mrToken}`,
        },
        body: JSON.stringify({ noticeId: mongoId }),
      });
      if (response.ok) {
        const result = await response.json();
        const emailNotice = result?.data;
        document.getElementById(`email_detail_div${idx}`).innerHTML = `
          <div>
            <strong>From:</strong> ${emailNotice.emailFrom || ''}<br/>
            <strong>To:</strong> ${emailNotice.emailto || ''}<br/>
            <strong>Subject:</strong> ${emailNotice.subject || ''}<br/>
            <strong>Date:</strong> ${emailNotice.sentDate ? new Date(emailNotice.sentDate).toLocaleString() : ''}<br/>
            <div className="card">
			<div className="card-body">
            <div style="white-space: pre-wrap;">${emailNotice.body || ''}</div>
			</div>
			</div>
          </div>
        `;
      } else {
        document.getElementById(`email_detail_div${idx}`).innerHTML = '<span class="text-danger">Failed to load email details.</span>';
      }
    } catch {
      document.getElementById(`email_detail_div${idx}`).innerHTML = '<span class="text-danger">Error loading email details.</span>';
    }
  };
  
  const handleFileChange = (event) => {
    const newFiles = Array.from(event.target.files);

    // Merge new files with existing, avoiding duplicates by name+size
    const mergedFiles = [
      ...selectedFiles,
      ...newFiles.filter(
        nf => !selectedFiles.some(sf => sf.name === nf.name && sf.size === nf.size)
      ),
    ];

    setSelectedFiles(mergedFiles);
    event.target.value = '';
  };


  // Remove file handler
  const handleRemoveFile = (index) => {
    setSelectedFiles(files => files.filter((_, i) => i !== index));
  };
  


  const handleAttchSelection = (e) => {
    const selectedMongoId = e.target.value;
    const matchedAttachment = allAttachments.find(att => String(att.id) === String(selectedMongoId));
    if (matchedAttachment) {
      PopupService.getInstance().showMessage(
        `The file "${matchedAttachment.fileName}" is already attached.`,
        false
      );
      e.target.checked = false; // Optionally uncheck the box
      return;
    }
    // Continue with your logic for new attachment selection
  };
  

  function processAttachmentResponse(response, result, setAttachments, setClientAttachments, data) {
    if (response.ok && result.statusCode === 200) {
      
      const attList = result?.data?.EXPORT_PAYLOAD.attachmentList || [];
      if (attList.length > 0) {
		
        // Add NT attachments to clientAttachments
        const ntAttachments = attList.filter(att => att.attachmentType === 'NT');
        if (ntAttachments.length > 0) {
          setClientAttachments(prev => {
            const updated = { ...prev };
            ntAttachments.forEach(att => {
              if (!updated[att.mongoId]) updated[att.mongoId] = [];
              updated[att.mongoId].push([
                att.mongoId,
                att.filename,
                att.attachmentType
              ]);
            });
            return updated;
          });
        }
        // Add non-NT attachments to attachments
        const otherAttachments = attList.filter(att => att.attachmentType !== 'NT');
        if (otherAttachments.length > 0) {
          setAttachments(prev => [
            ...prev,
            ...otherAttachments
              .filter(att => !prev.some(existing => existing.mongoId === att.mongoId))
              .map(att => ({
                ...att,
                type: 'alert',
                id: att.mongoId,
                fileName: att.filename,
                clientId: data.clientId,
                attachmentType: att.attachmentType || 'SA'
              }))
          ]);
        }
      }
      return true;
    }
    return false;
  }

  
  async function addAttachmentToAlert() {
	const form = document.getElementById('exportForm');
	const formData = new FormData(form);
	if (selectedFiles.length > 0) {
	  selectedFiles.forEach((file) => {
	    formData.append('attachment', file);
	  });
	}
	formData.append('mrNumber', data.mrNumber);
	formData.append('clientId', data.clientId);
	formData.append('enteredBy', username);
	formData.append('username', username);
	formData.append('alertTitle',supportAlert.alertTitle);
	formData.append('mongoId',data.mongoId);
    setLoading(true);
  
    await callApi(async () => {
  	  try {
  	    const response = await apiFetch(`${config.API_BASE_URL}/addAttachmentToAlert`, {
  	      method: 'POST',
  	      body: formData,
  	      headers: {
  	        'X-Username': username,
  	        'Authorization': `Bearer ${mrToken}`
  	      }
  	    });

  	    const result = await response.json();
		const isResponseOK = processAttachmentResponse(response, result, setAttachments, setClientAttachments, data);
        if(isResponseOK){
			PopupService.getInstance().showMessage(result.message || 'Alert Attachment saved successfully!', true);
			// Uncheck all noticeFileIds checkboxes
			document.querySelectorAll('input[name="noticeFileIds"]').forEach(cb => cb.checked = false);

		}else{
			PopupService.getInstance().showMessage(result.message || 'Error adding attachment(s) to Alert!', false);
		}

		
  	  } catch (error) {
  	    PopupService.getInstance().showMessage('Error saving AlertClient - ' + error, false);
  	  }finally{
  		setLoading(false);
  		setIsApiLoading(false);
  	  }
    });		  
  }

  async function exportAlertToTracking() {
    const form = document.getElementById('exportForm');
    const formData = new FormData(form);
    if (selectedFiles.length > 0) {
      selectedFiles.forEach((file) => {
        formData.append('attachment', file);
      });
    }
    formData.append('mrNumber', data.mrNumber);
    formData.append('clientId', data.clientId);
    formData.append('enteredBy', username);
	formData.append('username', username);
	formData.append('alertTitle',supportAlert.alertTitle);
	formData.append('mongoId',data.mongoId);

    
    setLoading(true);
	const isRunning = await isPythonApiRunning();
	  if (!isRunning) {
	    PopupService.getInstance().showMessage('Alert cannot be exported at this time as some of the services (Python End Point) essential to export alert is down!', false);
	    setLoading(false);
	    setIsApiLoading(false);
	    return;
	  }
    await callApi(async () => {
  	  try {
  	      const response = await apiFetch(`${config.API_BASE_URL}/exportAlertToTrack`, {
  	      method: 'POST',
  	      body: formData,
  	      headers: {
  	        'X-Username': username,
  	        'Authorization': `Bearer ${mrToken}`
  	      }
  	    });

  	    const result = await response.json();
		//const isResponseOK = processAttachmentResponse(response, result, setAttachments, setClientAttachments, data);
         if (response.ok && result.statusCode === 200) {
			PopupService.getInstance().showMessage(result.message || 'Alert exported saved successfully, now exporting  attachments and product matches', true);
			const exportPayload = result?.data?.EXPORT_PAYLOAD;
			const attList = result?.data?.EXPORT_PAYLOAD.attachmentList || [];
			setStageId(exportPayload.stageId);
			if (attList.length > 0) {
				try {
				  exportPayload.mongoId = data.mongoId;
			      const exportResponse = await apiFetch(`${config.API_PY_URL}/exportAttachmentNProductMatches`, {
			        method: 'POST',
			        headers: {
			          'Content-Type': 'application/json',
			          'X-Username': username,
			          'Authorization': `Bearer ${mrToken}`
			        },
			        body: JSON.stringify(exportPayload) // Python expects a list of lists
			      });
			      const exportResult = await exportResponse.json();
			      if (exportResponse.ok && exportResult.status === 'OK') {
			        // Optionally show a success message
			        PopupService.getInstance().showMessage('Attachments exported to tracking system', true);
			      } else {
			        PopupService.getInstance().showMessage(exportResult.message || 'Failed to export attachments', false);
			      }
			    } catch (err) {
			      PopupService.getInstance().showMessage('Error exporting attachments: ' + err, false);
			    }
			}
		}else{
			PopupService.getInstance().showMessage(result.message || 'Error exporting Alert to client', false);
		}
		
  	  } catch (error) {
  	    PopupService.getInstance().showMessage('Error saving AlertClient - ' + error, false);
  	  }finally{
  		setLoading(false);
  		setIsApiLoading(false);
  	  }
    });		  
  }

  
  async function associateClient() {
    const form = document.getElementById('exportForm');
    const formData = new FormData(form);
    if (selectedFiles.length > 0) {
      selectedFiles.forEach((file) => {
        formData.append('attachment', file);
      });
    }
    formData.append('mrNumber', data.mrNumber);
    formData.append('clientId', data.clientId);
    formData.append('enteredBy', username);
	formData.append('uploadMode', "selected");
    
    setLoading(true);
    await callApi(async () => {
  	  try {
  	    const response = await apiFetch(`${config.API_BASE_URL}/saveAlertClient`, {
  	      method: 'POST',
  	      body: formData,
  	      headers: {
  	        'X-Username': username,
  	        'Authorization': `Bearer ${mrToken}`
  	      }
  	    });

  	    
		const result = await response.json();
		const isResponseOK = processAttachmentResponse(response, result, setAttachments, setClientAttachments, data);
        if(isResponseOK){
			PopupService.getInstance().showMessage(result.message || 'Alert Associated to client  successfully !', true);
			document.querySelectorAll('input[name="noticeFileIds"]').forEach(cb => cb.checked = false);
			setClientAssociation('YES');

			// Uncheck all noticeFileIds checkboxes
			document.querySelectorAll('input[name="noticeFileIds"]').forEach(cb => cb.checked = false);
			// Reset the form fields
			form.reset();
			// Optionally reset receivedDate and selectedFiles state if needed
			setReceivedDate(null);
			setSelectedFiles([]);

		}else{
			PopupService.getInstance().showMessage(result.message || 'Error Associating client to alert !', false);
		}
  	  } catch (error) {
  	    PopupService.getInstance().showMessage('Error saving AlertClient', false);
  	  }finally{
  		setLoading(false);
  		setIsApiLoading(false);
  	  }
    });		  
  }
  


  async function reExportProductMatches() {
    setLoading(true);
    if (!stageId || String(stageId).trim() === '') {
      PopupService.getInstance().showMessage(
        'This alert was not found in the tracking system as there is no stageId.',
        false
      );
      setLoading(false);
      setIsApiLoading(false);
      return;
    }
    const isRunning = await isPythonApiRunning();
    if (!isRunning) {
      PopupService.getInstance().showMessage(
        'Product matches cannot be exported at this time as some of the services (Python End Point) essential to export product matches is down!',
        false
      );
      setLoading(false);
      setIsApiLoading(false);
      return;
    }
    await callApi(async () => {
      try {
        const response = await apiFetch(`${config.API_PY_URL}/reExportProductMatches`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Username': username,
            'Authorization': `Bearer ${mrToken}`
          },
          body: JSON.stringify({
            mongoId: data.mongoId,
            stageId: stageId
          })
        });
        const result = await response.json();
        if (response.ok && result.status === 'OK') {
          PopupService.getInstance().showMessage('Product matches re-exported successfully!', true);
        } else {
          PopupService.getInstance().showMessage(result.message || 'Failed to re-export product matches', false);
        }
      } catch (error) {
        PopupService.getInstance().showMessage('Error re-exporting product matches - ' + error, false);
      } finally {
        setLoading(false);
        setIsApiLoading(false);
      }
    });
  }

  
  async function addProductMatches() {
    setLoading(true);
    const isRunning = await isPythonApiRunning();
    if (!isRunning) {
      PopupService.getInstance().showMessage(
        'Product matches cannot be added at this time as some of the services (Python End Point) essential to export product matches is down!',
        false
      );
      setLoading(false);
      setIsApiLoading(false);
      return;
    }
	if (!stageId || String(stageId).trim() === '') {
	      PopupService.getInstance().showMessage(
	        'This alert was not found in the tracking system as there is no stageId.',
	        false
	      );
	      setLoading(false);
	      setIsApiLoading(false);
	      return;
	    }
    await callApi(async () => {
      try {
        const response = await apiFetch(`${config.API_PY_URL}/addProductMatches`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-Username': username,
            'Authorization': `Bearer ${mrToken}`
          },
          body: JSON.stringify({
            mongoId: data.mongoId,
            stageId: stageId
          })
        });
        const result = await response.json();
        if (response.ok && result.status === 'OK') {
          PopupService.getInstance().showMessage('Product matches added successfully!', true);
        } else {
          PopupService.getInstance().showMessage(result.message || 'Failed to add product matches', false);
        }
      } catch (error) {
        PopupService.getInstance().showMessage('Error adding  product matches - ' + error, false);
      } finally {
        setLoading(false);
        setIsApiLoading(false);
      }
    });
  }

  return (
    <>
      <Header />
      <br />
      <br />
      <br />
      <div className="container-fluid text-secondary">
	     <div className="card text-secondary" >
	  			<div className="card-header d-flex justify-content-between align-items-center">
				    <span>
				      <span className="pointer-cursor" 
					  title={`Back to matching summary (page ${sessionStorage.getItem('lastPage')})`}
					  onClick={handleBack}>Matching Summary</span> <i className="fa fa-arrow-right"></i> Export Alert
				    </span>
				    <button
				      id="back_summary_btn"
				      type="button"
				      className="btn btn-sm btn-secondary"
				      onClick={handleBack}
					  title={`Back to matching summary (page ${sessionStorage.getItem('lastPage')})`}
				    >
				      Back to Matching Summary
				    </button>
				  </div>
	  			<div className='card-body  custom-card-bg'>
				
	  			  <div className="card">
				  <div className="card-header">Export - {data.mrNumber} - {data.clientName} ({data.clientId}) to Tracking</div>
				  <div className='card-body'>				  
				  <div className="row">
				  <div className="form-group col-md-6" id="existing_attach_div">
				<div>
				  <ul className="list-group" id="alert_attachment_list_div">
					  <li className="list-group-item active" aria-current="true">{supportAlert.mrNumber}&nbsp;-&nbsp;Existing Alert Attachment(s)</li>
					  {allAttachments.length === 0 ? (
					    <li className="list-group-item text-danger">No Attachments found</li>
					  ) : (
						
					    allAttachments.map((file, idx) => (
					      <li className="list-group-item" key={idx}>
					        {file.clientId && <span className='text-primary'>{file.clientId}</span>}
					        {file.clientId && <>&nbsp;-&nbsp;</>}
							{file.type === 'alert' ? '*' : ''}
							<a className='text-secondary'
					          href="#"
					          onClick={e => {
					            e.preventDefault();
					            if (file.type === 'alert') {
					              downloadAttachment(file.id, file.fileName);
					            } else {
					              downloadAttachment(file.id, file.fileName, file.attachmentType);
					            }
					          }}
					        >
					          {file.fileName}
					        </a>
					        &nbsp;
							<span
							  className="badge bg-danger"
							  style={{ cursor: 'pointer' }}
							  onClick={() => {
							    if (file.type === 'alert') {
							      deleteAlertAttachment(file.id, data.clientId, 'SA');
							    } else if (file.type === 'client') {
							      // Pass both alertClientId and id for client type
							      deleteClientAttachment(file.id, file.clientId,'NT');
							    } else {
							      deleteAlertAttachment(file.id, file.attachmentType);
							    }
							  }}
							>
							  Delete Attachment
							</span>
					      </li>
					    ))
					  )}
					</ul>
					
					
					{allAttachments.length > 0 && (
						
					  <figcaption className="blockquote-footer">
					    <br/>* attachments are uploaded externally to the alert <cite title="Source Title">{data.mrNumber}</cite>
					  </figcaption>
					)}

										
				  </div>
				  </div>
				    <div className="form-group col-md-6" id="alert_detail_div">
					{clientAssociation === 'YES' ? (
					    <div className="alert alert-success">Alert {supportAlert.mrNumber} - {supportAlert.alertTitle} is associated with client {data.clientName} ({data.clientId})					
						<br/>					
						<span className="badge bg-success pointer-cursor" onClick={() => setShowAlertDetails((prev) => !prev)} disabled={!supportAlert}>
						    {showAlertDetails ? ( <>
							    <i className="fa fa-minus-square"></i> Collapse Alert Details
							  </>
							) : (
							  <>
							    <i className="fa fa-plus-square"></i> Expand Alert Details
							  </>
							)}
						</span>
						</div>
					  ) : (
					    <div className="alert alert-warning">Alert {supportAlert.mrNumber} - {supportAlert.alertTitle} is not associated with client {data.clientName} ({data.clientId})					
						<br/>
						<span className="badge bg-success pointer-cursor" onClick={() => setShowAlertDetails((prev) => !prev)} disabled={!supportAlert}>
						    {showAlertDetails ? ( <>
							    <i className="fa fa-minus-square"></i> Collapse Alert Details
							  </>
							) : (
							  <>
							    <i className="fa fa-plus-square"></i> Expand Alert Details
							  </>
							)}
						</span>
						</div>
					  )}
					{showAlertDetails && supportAlert && (
						 <div className="card">
						
						    <div className="card-header" id="detail_header">Alert Detail - {supportAlert.mrNumber}</div>
						    <div className="card-body text-secondary">
							
						        <div><strong>Alert Number:</strong> {supportAlert.mrNumber}
								&nbsp;<strong>Publish Date:</strong> 
								{format(new Date(supportAlert.publishDate), 'M/dd/yyyy')}
								</div>
						        <div><strong>Title:</strong> {supportAlert.alertTitle}<br /><br /></div>
								<div>
								  <strong>Description:</strong>{' '}
								  <span
								    dangerouslySetInnerHTML={{
								      __html: unescapeHtml(supportAlert.productDesc || '')
								    }}
								  />
								  <br /><br />
								</div>
								<div><strong>Product Classification:</strong> {supportAlert.productClassification}
								&nbsp;<strong>Alert Class:</strong> {supportAlert.alertClass}
								&nbsp;<strong>Category:</strong> {supportAlert.category}
								&nbsp;<strong>Source:</strong> {supportAlert.alertSource}
								&nbsp;<strong>Source Number:</strong> {supportAlert.sourceNumber}
								&nbsp;<strong>Alert Type:</strong> {supportAlert.alertType}
								&nbsp;<strong>FDA Recall Status:</strong> {supportAlert.fdaAlertStatus}
								&nbsp;<strong>Vendor Requests Response:</strong> {supportAlert.vendorRequestsResponse}<br /><br />
								</div>
								<div><strong>Manufatcurer:</strong> {supportAlert.manufacturer}
								&nbsp;<strong>Recaller:</strong> {supportAlert.recaller}<br /><br />
								</div>
								<div>
								  <strong>Reason:</strong>{' '}
								  <span
								    dangerouslySetInnerHTML={{
								      __html: unescapeHtml(supportAlert.reason || '')
								    }}
								  />
								  <br /><br />
								</div>
								<div>
								  <strong>Recommended Action:</strong>{' '}
								  <span
								    dangerouslySetInnerHTML={{
								      __html: unescapeHtml(supportAlert.recommendedAction || '')
								    }}
								  />
								  <br /><br />
								</div>												
								<div><strong>NDC:</strong> {supportAlert.ndc}<br /><br /></div>
								<div><strong>UPC:</strong> {supportAlert.upc}<br /><br /></div>
								<div>
								  <strong>Catalog Number:</strong>{' '}
								  <span
								    dangerouslySetInnerHTML={{
								      __html: unescapeHtml(supportAlert.catalogNumber || '')
								    }}
								  />
								  <br /><br />
								</div>
								<div><strong>Distribution:</strong> {supportAlert.distribution}
								&nbsp;<strong>Quantity:</strong> {supportAlert.quantity}
								&nbsp;<strong>Source URL:</strong> {supportAlert.sourceUrl}
								<br /><br />
								</div>												
								<div>
								  <strong>Contact Info:</strong>{' '}
								  <span
								    dangerouslySetInnerHTML={{
								      __html: unescapeHtml(supportAlert.contactInfo || '')
								    }}
								  />
								  <br /><br />
								</div>												
								<div>
								  <strong>Misc Info:</strong>{' '}
								  <span
								    dangerouslySetInnerHTML={{
								      __html: unescapeHtml(supportAlert.miscInfo || '')
								    }}
								  />
								  <br /><br />
								</div>
								<span className="badge bg-success pointer-cursor" onClick={() => setShowAlertDetails((prev) => !prev)} disabled={!supportAlert}>
								    {showAlertDetails ? ( <>
									    <i className="fa fa-minus-square"></i> Collapse Alert Details
									  </>
									) : (
									  <>
									    <i className="fa fa-plus-square"></i> Expand Alert Details
									  </>
									)}
								</span>
					        </div>
							
					      </div>
						  
					    )}
				  	</div>
				  	
				    </div>
				  </div>
				  </div>
				  <br/>
				  <form name="exportForm" id="exportForm" encType="multipart/form-data">
				  <div className='card'>
				    <div className='card-header'>Email Notices for alert {data.mrNumber} - {data.clientName}</div>
					<div className='card-body'>
						<div className="row">
						<div className="form-group col-md-6" id="email_notices_div">
							  <label className="text-info fw-bold">Received From</label>
							  <ul className="list-group">
							  <li className="list-group-item active" aria-current="true">
							      Emails Received for {supportAlert.mrNumber} From the following sender(s)
							    </li>
							    {noticeTasks.length === 0 ? (
							      <li className="list-group-item text-danger">No Email Notices found</li>
							    ) : (
									noticeTasks.map((notice, idx) => (
									  <li className={`list-group-item ${idx % 2 === 0 ? 'list-group-item-secondary' : ''}`} key={idx}>
									    <input type="checkbox" value={notice.mongoId} name="noticeTaskIds"
									      onChange={handleCBChanged} id={notice.messageId}
									      style={{ marginRight: '8px' }} />
									    <span >{notice.emailFrom || notice.from}</span>&nbsp;-&nbsp;
										{notice.subject}&nbsp;
										<span className="badge bg-primary pointer-cursor"
									      onClick={() => {
									        if (expandedEmailIdx === idx) {
									          setExpandedEmailIdx(null);
									        } else {
									          handleEmailClicked(notice.messageId, idx);
									        }
									      }}
									    >									     
									      {expandedEmailIdx === idx ? (
									        <>
									         <i className="fa fa-minus-square badge-primary"></i>&nbsp;Collapse
									        </>
									      ) : (
									        <>
									          <i className="fa fa-plus-square"></i>&nbsp;Email Detail
									        </>
									      )}
									    </span>
									    &nbsp; received on <span className="text-secondary">{format(new Date(notice.emailDate), 'M/dd/yyyy HH:mm')}</span>
									    <div id={`email_detail_div${idx}`} style={{ display: expandedEmailIdx === idx ? 'block' : 'none' }}></div>
									  </li>
									))
							    )}
							  </ul>
							</div>
						
							<div className="form-group col-md-6" id="notice_attachment_div">
							    <label className="text-info fw-bold">Select Attachments from emails</label>	
								<ul className="list-group" id="alert_attachment_list_div">
								  <li className="list-group-item active" aria-current="true">
								    {supportAlert.mrNumber}&nbsp;-&nbsp;Email Notice Attachment(s)
								  </li>
								  {noticeTaskAttachments.length === 0 ? (
								    <li className="list-group-item text-danger">No Attachments found</li>
								  ) : (
							      noticeTaskAttachments.map((att, idx) => (
									<li className={`list-group-item ${idx % 2 === 0 ? 'list-group-item-secondary' : ''}`} key={idx} >
							          <input
							            type="checkbox"
							            name="noticeFileIds"
							            value={att.mongoId}
							            style={{ marginRight: '8px' }}
										onChange={handleAttchSelection}
							          />
							          <a className='text-secondary'
							            href="#"
							            onClick={e => {
							              e.preventDefault();
										  downloadAttachment(att.mongoId, att.filename, "NT");							              
							            }}
							          >
							            {att.filename}
							          </a>
							        </li>
							      ))
							    )}
							  </ul>
							</div>
						</div>						
					</div>
				  </div>
				  <br/>
				  <div className='card'>
				  <div className='card-header'>Add External Attachments</div>
				  <div className='card-body'>
				  
				  <div className="row">
             
				  	<div className="form-group col-md-2">
				  	<br/>
				  		<label className="text-info fw-bold">Received From(Others)</label>
				  		<input
				  		  type="text"
				  		  className="form-control"
				  		  id="recvd_from_others"
				  		  name="recvdFromOthers"
				  		  placeholder="Received from (others)"
				  		/>
				  	</div>
				  	<div className="form-group col-md-2">
				  	<br/>
				  		<label className="text-info fw-bold">Received Date</label>
				  		<div className="input-group">
				  	      <DatePicker
				  	        selected={receivedDate}
				  	        className="form-control"
				  	        id="received_date"
				  	        placeholderText="Select Received Date"
				  	        dateFormat="MM/dd/yyyy"
				  			name="receivedDate"
				  			onChange={(date) => setReceivedDate(date)}
				  	      />
				  	      
				  	    </div>
				  	</div>
				  	<div className="form-group col-md-2">
				  	<br/>
				  		<label className="text-info fw-bold">Received Mode</label>
				  		<select
				  		  id="sel_received_mode"
				  		  name="receivedMode"
				  		  className="form-select"
				  		 
				  		>
				  			<option value="">--Select Received Mode--</option>
				  		    <option value="Email">Email</option>
				  			<option value="Fax">Fax</option>
				  			<option value="Online">Online</option>
				  			<option value="Mail">Mail</option>
				  			<option value="Oyhers">Others</option>
				          </select>
				  	</div>
				  	<div className="form-group col-md-6">
				  	<br/>
				  		<label className="text-info fw-bold">Misc. Info</label>
				  		<textarea
				  		  className="form-control"
				  		  id="miscInfo"
				  		  name="miscInfo"
				  		  rows="3"
				  		  placeholder="Enter Misc Info Here"
				  		  
				  		></textarea>
				  	</div>
				  </div>
				  <div className="row">
					<div className="form-group col-md-6">
					    <br />
					    <label htmlFor="alert_file" className="text-info fw-bold">Upload File</label>
						<input
						  type="file"
						  className="form-control"
						  id="alert_file"
						  name="alert_file"
						  multiple
						  onChange={handleFileChange}
						/>
						{selectedFiles.length > 0 && (
						  <ul className="mt-2">
						    {selectedFiles.map((file, idx) => (
						      <li key={idx}>
						        {file.name}
						        <button
						          type="button"
						          className="btn btn-link btn-sm text-danger ms-2"
						          onClick={() => handleRemoveFile(idx)}
						        >
						          Remove
						        </button>
						      </li>
						    ))}
						  </ul>
						)}
					  </div>
				  </div>
				  		  
				</div>
				
				</div>
				</form>
				<div className="form-row d-flex justify-content-center mt-3">
				{ alertExported === 'YES' ? (
					<div style={{ display: 'flex', gap: '12px' }}>
					<button
  				      type="button"
  				      id="add_attachments"
  				      className="btn btn-danger btn-sm"
  				      onClick={reExportProductMatches}
  				    >
  				      Re Export Product Matches
  				    </button>
					
					<button
				      type="button"
				      id="create_alert"
				      className="btn btn-danger btn-sm"
				      onClick={addProductMatches}
				    >
				      Add to Existing Product Matches
				    </button>
					</div>
				):(
					clientAssociation === 'YES' ? (
					  <div style={{ display: 'flex', gap: '12px' }}>
					  <button
	  				      type="button"
	  				      id="add_attachments"
	  				      className="btn btn-secondary btn-sm"
	  				      onClick={addAttachmentToAlert}
	  				    >
	  				      Add Attachments
	  				    </button>
					    <button
					      type="button"
					      id="create_alert"
					      className="btn btn-danger btn-sm"
					      onClick={exportAlertToTracking}
					    >
					      Export Alert
					    </button>
					    
					  </div>
					) : (
					  <button
					    type="button"
					    id="create_alert"
					    className="btn btn-danger btn-sm"
					    onClick={associateClient}
					  >
					    Asscoiate Alert To Client
					  </button>
					)
				)
				}
				
				</div>  
			</div>				  
		  </div>				 
		</div>				  
      <Footer />
    </>
  );
};

export default ExportAlert;
